import { newListenerEffect as newListenerEffect$1 } from './newListenerEffect.js';

const getMappedActions = (store, React, mapActions) => React.useMemo(() => mapActions ? mapActions(store.actions) : store.actions, [mapActions, store.actions]);

function customHook(store, React, mapState, mapActions) {
  const state = mapState ? mapState(store.state) : store.state;
  const actions = getMappedActions(store, React, mapActions);
  const originalHook = React.useState(Object.create(null))[1];
  React.useEffect(newListenerEffect$1(store, mapState, originalHook), []); // eslint-disable-line

  return [state, actions];
}

export { customHook };
